import styled, { css } from 'styled-components';

import { useStateContext } from '../../store/stateContext';
import CommentCard from '../comment';

import type { Comment } from '../../types';

const CommentCardStyled = styled.div`
  margin-bottom: 8px !important;
`;

const CommentsContainer = styled.div<{ isUserFormOpen: boolean }>`
    background-color: transparent;
    border-radius: 8px !important; /* 0.5rem = 8px */
    width: 100%;
    max-height: 384px !important; /* 24rem = 384px */
    overflow: auto !important;
    
    @media (min-width: 768px) {
        max-width: 360px !important;
    }

    ${props => props.isUserFormOpen && css`
        height: 100vh !important;
    `}
`;

function Comments({ isUserFormOpen }: { isUserFormOpen: boolean }) {
    const { state } = useStateContext();
    const comments: Comment[] = state.data.data;
    const isDarkMode = state.themeMode === 'dark';

    return (
        <CommentsContainer isUserFormOpen={isUserFormOpen}>
            {comments.map((comment) => (
                <CommentCardStyled key={comment.id}>
                    <CommentCard key={comment.id} comment={comment} background={isDarkMode ? 'white' : '#625F74'} />
                </CommentCardStyled>
            ))}
        </CommentsContainer>
    );
}

export default Comments;
